import { StatusHistoryEntry } from "../../types/deals";
import { CheckCircle2, Clock, FileText, IndianRupee, PauseCircle, ThumbsDown, CircleDot } from "lucide-react";

function iconFor(status: string) {
  switch (status) {
    case "Deal Shared":
      return CircleDot;
    case "Credit Discussion Completed":
      return CheckCircle2;
    case "Under Review":
      return Clock;
    case "Unresponsive":
      return PauseCircle;
    case "On Hold":
      return PauseCircle;
    case "Term Sheet Shared":
      return FileText;
    case "Rejected":
      return ThumbsDown;
    case "Sanctioned":
      return IndianRupee;
    case "Disbursed":
      return CheckCircle2;
    default:
      return Clock;
  }
}

interface StatusTimelineProps { entries: StatusHistoryEntry[], adminUserNames: any[] }

export function StatusTimeline({ entries, adminUserNames }: StatusTimelineProps) {
  return (
    <ol className="relative border-s space-y-5">
      {entries.map((e, idx) => {
        const Icon = iconFor(e.status ?? "");
        return (
          <li key={idx} className="relative pl-2">
            
            <div className="flex flex-col gap-2 min-w-0">
              <div className="flex items-center justify-between">
                <div className="text-sm font-medium flex items-center gap-2"> <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary text-primary shrink-0">
              <Icon className="h-3.5 w-3.5" /> 
            </span><span className="text-sm font-medium">{e.status}</span></div>
                <div className="text-[10px] text-muted-foreground">
                  {new Date(e.timestamp).toLocaleDateString("en-GB")} •{" "}
                  {adminUserNames.find((u: any) => String(u.id) === String(e.updatedBy))?.name || e.updatedBy}
                </div>
              </div>

              {/* Simplified Details: Remark, Reason, Status, Date */}
              <div className="space-y-1">
                {e.note && (
                  <div className="text-xs"><span className="font-medium">Remark:</span> <span className="text-muted-foreground">{e.note}</span></div>
                )}
                {e.reason && (
                  <div className="text-xs"><span className="font-medium">Reason:</span> <span className="text-muted-foreground">{e.reason}</span></div>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
